@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<app-generic-loading [loading]="isLoadingEmitter"></app-generic-loading>

<!-- Gestione della timeline -->
<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="index">1</span>
            {{'components.decision-table.decision-table-dashboard.project-timeline' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <div class="stepper-container col-12">
            <p class="headline float-left">
              {{'components.decision-table.decision-table-dashboard.evaluation-session' | translate}}
            </p>
            <p class="headline float-right">
              {{'generic.report' | translate}}
            </p>
            <div class="timeline">
              @for (session of evaluation_sessions_row_1; track session; let i = $index) {
                <div style="cursor: pointer;" (click)="onClickEvaluationSession(i)" class="step-container" [ngClass]="session.collecting == true ? 'current' : ''">
                  <ng-container>
                    <div class="step" [ngClass]="{'selected-step': session.id === currentEvaluationSessionDashboard.id && !session?.collecting}">{{i + 1}}</div>
                    @if (session.evaluation_start) {
                      <div class="step-label">{{session.evaluation_start | formatdate | date: 'short'}} <br>
                        @if (!session.collecting) {
                          <span>{{session.evaluation_end | formatdate | date:'short'}}</span>
                        }
                      </div>
                    }
                    @if (!session.evaluation_start) {
                      <div class="step-label">{{'components.decision-table.decision-table-dashboard.not-started-yet' | translate}}</div>
                    }
                  </ng-container>
                </div>
              }
              @if (evaluation_sessions_row_1.length < evaluation_sessions_by_row) {
                <div class="step-container icon-container">
                  <div class="step">
                    <i class="icon-Flag"></i>
                  </div>
                </div>
              }
              <!-- <div class="step-container current">
              <div class="step">2</div>
              <div class="step-label">17 Luglio 2020</div>
            </div> -->
          </div>
        </div>
        @if (evaluation_sessions_row_1.length >= evaluation_sessions_by_row) {
          <div class="stepper-container col-12">
            <div class="timeline until-end">
              @for (session of evaluation_sessions_row_2; track session; let i = $index) {
                <div class="step-container" [ngClass]="session.tracker == true ? 'current' : ''">
                  <ng-container>
                    <div class="step">{{evaluation_sessions_by_row + i+1}}</div>
                    <div class="step-label">{{session.decision_start}}</div>
                  </ng-container>
                </div>
              }
              <div class="step-container icon-container">
                <div class="step">
                  <i class="icon-Flag"></i>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="row col-12 d-flex justify-content-between mb-3">
        @if (weights_from_framework_or_table_exists) {
          <button
            matButton="filled"
            color="primary"
            class="ml-2"
            (click)="editSessionWeights(false)"
            >
            {{
            "components.decision-table.show-decision-table.view-weights"
            | translate
            }}
          </button>
        }
        <button class="ml-auto" matButton="filled" color="primary" [routerLink]="['/decision/'+decision_table.id+'/show']" routerLinkActive="router-link-active" >{{'components.decision-table.decision-table-dashboard.go-to-table-management' | translate}}</button>

        @if (isVirtualAssistantEnabled$ | async) {
          <button
            class="size-small danger text-white"
            matButton="filled"
            (click)="onClickModalDashboardAiExplanation()"
            >
            {{'modal.modal-virtual-assistant.title' | translate}}
          </button>
        }

      </div>

    </mat-expansion-panel>
  </mat-accordion>
</div>
</div>

@if (loadingComponent && getAnalysisService().isConsensusByType(decision_table?.framework?.analysis_type)) {
  <app-consensus-decision-table-dashboard
    [decision_table]="decision_table"
    [evaluation_session_dashboard]="currentEvaluationSessionDashboard"
  ></app-consensus-decision-table-dashboard>
}

@if (loadingComponent && getAnalysisService().isMultiobjectiveByType(decision_table?.framework?.analysis_type)) {
  <app-multiobjective-decision-table-dashboard
    [decision_table]="decision_table"
    [evaluation_session_dashboard]="currentEvaluationSessionDashboard"
  ></app-multiobjective-decision-table-dashboard>
}

@if (loadingComponent && getAnalysisService().isMulticriteriaByType(decision_table?.framework?.analysis_type)) {
  <app-multicriteria-decision-table-dashboard
    [decision_table]="decision_table"
    [evaluation_session_dashboard]="currentEvaluationSessionDashboard"
  ></app-multicriteria-decision-table-dashboard>
}
